import config from '../../config/config';

export const Page = {
    DEFAULT: 'default',
    WALLET_SETTLEMENT: '/admin/wallet/settlement',
    APP_DATA_NFT: '/admin/app/fixAppData/nft',
    APP_GAME_CAMPAIGN: '/admin/app/game/campaign',
    APP_CAMPAIGN_RECOMMEND_ALL: '/admin/app/campaign/recommend/all',
    APP_CAMPAIGN_RECOMMEND_FINISHED: '/admin/app/campaign/recommend/finished',
    APP_CAMPAIGN_SPECIAL_ALL: '/admin/app/campaign/special/all',
    APP_CAMPAIGN_SPECIAL_FINISHED: '/admin/app/campaign/special/finished',
    APP_MAINTENANCE: '/admin/app/maintenance',
    APP_DEV_IMAGE_UPLOAD: '/admin/app/devImageUpload',
    APP_BASIC_MISSION: '/admin/app/basic/mission',
    APP_BASIC_MISSION_REWARD_LOG: '/admin/app/basic/mission/basicMissionRewardLog',
    APP_BASIC_REFERRAL: '/admin/app/basic/referral',
    EVENT_BALANCE_MINING: '/admin/event/balance/mining',
    EVENT_BALANCE_MINING_LOG: '/admin/event/balance/log',
    EVENT_INVITATION: '/admin/event/newUser/invitation',
    EVENT_INVITATION_LOG: '/admin/event/newUser/invitation/log',
    EVENT_NEWUSER_FREENFT: '/admin/event/newUser/freeNFT',
    EVENT_NEWUSER_FREENFT_LOG: '/admin/event/newUser/freeNFT/log',
    EVENT_USERACTIVITY_STARTERPACK: '/admin/event/userActivity/starterPack',
    EVENT_USERACTIVITY_STARTERPACK_LOG:
        '/admin/event/userActivity/starterPack/log',
    EVENT_USERACTIVITY_DRAW_ITEM: '/admin/event/userActivity/drawitem',
    USER_PERPLAYUSER: '/admin/user/perplayUser',
    USER_MESSAGE: '/admin/user/message',
    FILE_BASED_POST: '/admin/user/fileBasedPost',
    LOG_USER_LOGIN: '/admin/log/user/login',
    LOG_USER_SESSION: '/admin/log/user/session',
    LOG_USER_WALLET_CONNECTION: '/admin/log/user/walletConnection',
    LOG_PERPLAY_GAMESESSION: '/admin/log/perplay/gamesession',
    LOG_PERPLAY_SPECIALBOX: '/admin/log/perplay/specialbox',
    LOG_PERPLAY_POWERCHARGE: '/admin/log/perplay/powerCharge',
    LOG_PERPLAY_LEVELUP: '/admin/log/perplay/levelUp',
    LOG_PERPLAY_BREED: '/admin/log/perplay/breed',
    LOG_PERPLAY_EVOLVE: '/admin/log/perplay/evolve',
    LOG_PERPLAY_WALLETTRANSACTION: '/admin/log/perplay/walletTransaction',
    LOG_PERPLAY_NFTTRANSACTION: '/admin/log/perplay/nftTransaction',
    LOG_PERPLAY_INVENTORYTRANSACTION: '/admin/log/perplay/inventoryTransaction',
    LOG_PERPLAY_GEMSOCKET: '/admin/log/perplay/gemSocketReset',
    LOG_PERPLAY_RESETSTATS: '/admin/log/perplay/statReset',
    LOG_PERPLAY_CHANGENICKNAME: '/admin/log/perplay/nickname',
    LOG_PERPLAY_GEMSOCKETUPDATE: '/admin/log/perplay/gemSocketUpdate',
    LOG_PERPLAY_NFT_RESTORE: '/admin/log/perplay/nftRestore',
    LOG_PERPLAY_NFT_REPAIR: '/admin/log/perplay/nftRepair',
    LOG_PERPLAY_NFT_RENTAL: '/admin/log/perplay/nftRental',
    LOG_PERPLAY_STORED_POWER: '/admin/log/perplay/storedPower',
    LOG_PERPLAY_ITEM_BOX: '/admin/log/perplay/itemBox',
    LOG_PERPLAY_GOOGLE_STORE_PURCHASE: '/admin/log/perplay/googleStore',
    BACKOFFICE_MANAGER: '/admin/backoffice/manager',
    BACKOFFICE_LOG: '/admin/backoffice/log',
    BACKOFFICE_CONNECTIP: '/admin/backoffice/connectIP',
    EVENT_RAFFLE_MAIN: '/admin/event/raffle',
    GOOGLE_STORE_LIST: '/admin/app/fixedAppData/googleStore',
    EVENT_NOTICE_LIST: '/admin/event/notice',
    EVENT_POPUP_LIST: '/admin/event/event',
    LOG_PERPLAY_PILOT: '/admin/log/perplay/pilot',
};

class PaginationOptions {
    constructor(repo) {
        if (repo) {
            this.repo = repo;
        } else {
            // 주입된 repo가 없으면 구글 시트를 기본으로 설정한다.
            this.repo = new GoogleSheetRepo();
        }

        // 데이터도 없고 기본 데이터도 없을 때 사용할 기본 데이터를 설정한다.
        this.defaultOption = {
            key: 'default',
            list_count_enable: true,
            list_count_elements: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
            top_paging: true,
            bottom_paging: false,
        };
    }

    /**
     * 경고 제거 위해 체이닝 연산 ? 사용
     * */
    static async getInstance() {
        if (!PaginationOptions.instance) {
            const repo = new GoogleSheetRepo();
            PaginationOptions.instance = new PaginationOptions(repo);
            await PaginationOptions.instance.initialize();
        }
        return PaginationOptions.instance;
    }

    async initialize() {
        if (!this.repo) {
            this.repo = new GoogleSheetRepo();
        }
        await this.repo.initialize();
        // console.log('페이지 목록 Config 초기화 완료');
    }

    /**
     * 페이지 옵션 데이터를 리스트로 반환한다.
     * @return {Array}
     */
    getList() {
        return this.repo.getList();
    }

    /**
     * 해당 키의 페이지 옵션 데이터를 반환한다.
     * @param {string} key
     * @return {Object}
     */
    getData(key) {
        const data = this.repo.getData(key);
        return data ?? this.defaultOption;
    }

    /**
     * 해당 경로에 포함되는 키를 가진 페이지 옵션 데이터를 반환한다.
     * @param {string} path
     * @return {Object}
     */
    getDataByPath(path) {
        const data = this.repo.getDataByPath(path);
        return data ?? this.defaultOption;
    }
}

/**
 * 페이지 옵션 정보를 가져올 Repository에 대한 추상 클래스
 */
class Repo {
    constructor() {
        this.map = new Map();
        this.defaultKey = 'default';
    }

    async initialize() {
        throw new Error('This class is abstract class');
    }

    getList() {
        const list = Array.from(this.map.values());
        return list;
    }

    getData(key) {
        const data = this.map.get(key);
        return data ?? this.map.get(this.defaultKey);
    }

    /**
     * 페이지 url로부터 페이지 옵션 데이터를 가져온다.
     *
     */
    getDataByPath(path) {
        console.assert(path);
        const keys = [...this.map.keys()];
        const key = keys.find((x) => path.includes(x));
        return this.getData(key ?? this.defaultKey);
    }
}

/**
 * 페이지 옵션을 구글 시트로부터 가져오는 Repository 클래스
 */
export class GoogleSheetRepo extends Repo {
    constructor() {
        super();
        this.url = config.PAGE_OPTION_URL;
    }

    async initialize() {
        try {
            const res = await fetch(this.url);
            const json = await res.json();

            const list = [...json.data];
            list.forEach((row) => {
                if (Object.keys(row).includes('key')) {
                    this.map.set(row.key, row);
                }
            });
            // console.log(`GoogleSheetRepo 페이지 옵션 데이터 세팅 완료!!!`);
        } catch (e) {
            console.error(e);
        }
    }
}

export default PaginationOptions;
